var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title-16 mb20" }, [_vm._v("考核流程")]),
    _vm._v(" "),
    _c("div", { staticClass: "flex pt-20" }, [
      _c("div", { staticClass: "process-left" }, [
        _c(
          "div",
          { staticClass: "process-left-con" },
          _vm._l(_vm.tableData, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "process-left-list" },
              [
                _c(
                  "el-button",
                  {
                    class: index == _vm.tabIndex ? "" : "bgc-f7",
                    attrs: { type: "primary", round: "" },
                    on: {
                      click: function ($event) {
                        return _vm.clickBtn(index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(item.name) + "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                index != _vm.tableData.length - 1
                  ? _c("div", { staticClass: "process-icon" }, [
                      _c("i", { staticClass: "el-icon-d-arrow-left" }),
                    ])
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "process-right" },
        [
          _c(
            "el-col",
            _vm._l(_vm.tableData, function (item, index) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.id < 6,
                      expression: "item.id < 6",
                    },
                  ],
                  key: index,
                  staticClass: "process-right-list",
                  class: index == _vm.tabIndex ? "active" : "",
                },
                [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _vm._v(" "),
                  item.id == 5
                    ? _c("div", { staticClass: "process-right-con" }, [
                        _c("div", { staticClass: "left" }, [
                          _vm._v(_vm._s(_vm.$t("access.reviewer")) + "："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "right" },
                          [
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { checked: true, disabled: true },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeSuperior($event)
                                    },
                                  },
                                },
                                [_vm._v("高级领导")]
                              ),
                            ],
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "process-right-con" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm._v(_vm._s(item.title) + "："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "right" },
                      _vm._l(item.children, function (items, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "right-con" },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", circle: "" } },
                              [_vm._v(_vm._s(i + 1))]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(items.label))]),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  item.id == 5
                    ? _c("div", { staticClass: "process-right-con" }, [
                        _c("div", { staticClass: "left" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "right color444" }, [
                          _vm._v(_vm._s(_vm.$t("access.placeholder20"))),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }